export default __webpack_public_path__ + "static/media/bg-pooldecks.86e53702.jpg";